export const AVAILABLE_IMPORTS = [
  'externalCodes',
  'cards',
  'categories',
  'coupons',
  'districts',
  'itinerary',
  'partners',
  'prices',
  'productOptions',
  'products',
  'products~details@bundleTravel',
  'products~details@conditions',
  'products~details@productDescription',
  'products~details@fullDescription',
  'products~details@itinerary',
  'products~details@guru',
  'products~details@host',
  'products~slots',
  'products~stageDetails',
  'products~variants',
  'productStocks',
  'routes',
  'skidata-axess',
  'stages',
  'zones',
  'zones~details@translations',
] as const;

export const ORDER_EXPORT_FIELDS = [
  'billingAddress.address',
  'billingAddress.companyName',
  'billingAddress.sdi',
  'billingAddress.vatNumber',
  'clientInfo.os.name',
  'order.adminNotes',
  'order.amount',
  'order.code',
  'order.couponCode',
  'order.createdAtDate',
  'order.createdAtHour',
  'order.currency',
  'order.discount.customVariety',
  'order.discount.variety',
  'order.discountAmount',
  'order.discountCodes',
  'order.discountRestored',
  'order.fromCoupon',
  'order.paidAtDate',
  'order.paidAtHour',
  'order.paymentsAmount',
  'order.paymentsLeftover',
  'order.paymentGateway',
  'order.paymentGatewayFeePercentage',
  'order.paymentReason',
  'order.paymentTransactionId',
  'order.pickup',
  'order.pickupComplete',
  'order.productTypes',
  'order.shippingAmount',
  'order.source',
  'order.status',
  'order.tenant',
  'order.uid',
  'overwriteUserEmail.displayName',
  'overwriteUserEmail.email',
  'referral.medium',
  'referral.source',
  'referral.type',
  'shippingAddress.city',
  'shippingAddress.countryCode',
  'shippingAddress.name',
  'shippingAddress.notes',
  'shippingAddress.phone',
  'shippingAddress.state',
  'shippingAddress.street',
  'shippingAddress.surname',
  'shippingAddress.zipCode',
  'user.displayName',
  'user.email',
  'user.uid',
] as const;

export const ORDER_ITEM_EXPORT_FIELDS = [
  'billingAddress.address',
  'billingAddress.companyName',
  'billingAddress.sdi',
  'billingAddress.vatNumber',
  'clientInfo.os.name',
  'item.amount',
  'item.amountOptions',
  'item.amountPickup',
  'item.coins',
  'item.date',
  'item.discountAmount',
  'item.discountedPrice',
  'item.endDate',
  'item.extraDiscounts',
  'item.fromBundle',
  'item.generatedDiscountCodes',
  'item.hasInsurance',
  'item.netAmount',
  'item.notes',
  'item.parentItemUID',
  'item.partnerName',
  'item.phoneNumber',
  'item.pickupComplete',
  'item.price',
  'item.profiles',
  'item.quantity',
  'item.relatedItemUID',
  'item.rewardedCoins',
  'item.selectedOptions',
  'item.slotName',
  'item.snowitCommission',
  'item.snowitcardsInfo',
  'item.transferId',
  'item.uid',
  'item.variantName',
  'item.vat',
  'item.zoneName',
  'order.adminNotes',
  'order.code',
  'order.coins',
  'order.couponCode',
  'order.createdAtDate',
  'order.createdAtHour',
  'order.currency',
  'order.discount.customVariety',
  'order.discount.variety',
  'order.discountCodes',
  'order.discountRestored',
  'order.fromCoupon',
  'order.paidAtDate',
  'order.paidAtHour',
  'order.paymentsAmount',
  'order.paymentsLeftover',
  'order.paymentGateway',
  'order.paymentGatewayFeePercentage',
  'order.paymentReason',
  'order.paymentTransactionId',
  'order.pickup',
  'order.pickupComplete',
  'order.rewardedCoins',
  'order.shippingAmount',
  'order.snowitcardsInfo',
  'order.source',
  'order.status',
  'order.tenant',
  'order.uid',
  'order.updatedBy',
  'overwriteUserEmail.displayName',
  'overwriteUserEmail.email',
  'product.categoryName',
  'product.districtName',
  'product.durationHours',
  'product.markup',
  'product.name',
  'product.subCategoryName',
  'product.type',
  'product.uid',
  'providerOrder.amount',
  'providerOrder.cancelationOrderId',
  'providerOrder.confirmationNumber',
  'providerOrder.operationDate',
  'providerOrder.operationHour',
  'providerOrder.orderId',
  'providerOrder.profile',
  'providerOrder.providerName',
  'providerOrder.snowitcard',
  'providerOrder.snowitcardOriginal',
  'providerOrder.status',
  'providerOrder.qrcode',
  'referral.medium',
  'referral.source',
  'referral.type',
  'shippingAddress.city',
  'shippingAddress.countryCode',
  'shippingAddress.name',
  'shippingAddress.notes',
  'shippingAddress.phone',
  'shippingAddress.state',
  'shippingAddress.street',
  'shippingAddress.surname',
  'shippingAddress.zipCode',
  'user.displayName',
  'user.email',
  'user.uid',
] as const;

export type OrderExportField = (typeof ORDER_EXPORT_FIELDS)[number];
export type OrderItemExportField = (typeof ORDER_ITEM_EXPORT_FIELDS)[number];

export const ORDER_PARTNER_FIELD_PRESET: OrderExportField[] = [
  'order.code',
  'order.couponCode',
  'order.createdAtDate',
  'order.createdAtHour',
  'order.discount.customVariety',
  'order.discount.variety',
  'order.discountCodes',
  'order.fromCoupon',
  'order.paidAtDate',
  'order.paymentGateway',
  'order.pickup',
  'order.shippingAmount',
  'order.status',
  'order.tenant',
  'order.uid',
  'overwriteUserEmail.displayName',
  'overwriteUserEmail.email',
  'user.displayName',
  'user.email',
  'user.uid',
];

export const ORDER_ITEM_PARTNER_FIELD_PRESET: OrderItemExportField[] = [
  'item.amount',
  'item.amountOptions',
  'item.amountPickup',
  'item.date',
  'item.discountAmount',
  'item.discountedPrice',
  'item.hasInsurance',
  'item.netAmount',
  'item.notes',
  'item.parentItemUID',
  'item.partnerName',
  'item.phoneNumber',
  'item.pickupComplete',
  'item.price',
  'item.quantity',
  'item.snowitCommission',
  'item.snowitcardsInfo',
  'item.transferId',
  'item.uid',
  'item.vat',
  'item.zoneName',
  'order.code',
  'order.couponCode',
  'order.createdAtDate',
  'order.createdAtHour',
  'order.discount.customVariety',
  'order.discount.variety',
  'order.discountCodes',
  'order.fromCoupon',
  'order.paidAtDate',
  'order.paymentGateway',
  'order.pickup',
  'order.shippingAmount',
  'order.snowitcardsInfo',
  'order.status',
  'order.tenant',
  'order.uid',
  'overwriteUserEmail.displayName',
  'overwriteUserEmail.email',
  'product.categoryName',
  'product.districtName',
  'product.durationHours',
  'product.markup',
  'product.name',
  'product.type',
  'providerOrder.amount',
  'providerOrder.confirmationNumber',
  'providerOrder.operationDate',
  'providerOrder.providerName',
  'providerOrder.snowitcardOriginal',
  'providerOrder.status',
  'providerOrder.qrcode',
  'user.displayName',
  'user.email',
  'user.uid',
];

export const ORDER_ADMIN_FIELD_PRESET: OrderExportField[] = [...ORDER_PARTNER_FIELD_PRESET];

export const ORDER_ITEM_ADMIN_FIELD_PRESET: OrderItemExportField[] = [
  ...ORDER_ITEM_PARTNER_FIELD_PRESET,
  'item.endDate',
  'item.coins',
  'item.rewardedCoins',
  'order.coins',
  'order.rewardedCoins',
];
